import React from "react";
import { dict } from "../../dict";
const getComponentDefaultValue = () => React.createElement(React.Fragment, null);
const getNavLinkDefaultValue = (props) => (React.createElement(React.Fragment, null, props.children));
const getOpenEarlyExitTagModalDefaultValue = () => undefined;
const createDefaultContext = () => ({
    getIcon: getComponentDefaultValue,
    dictionary: { myBetsDictionary: dict },
    getNavLink: getNavLinkDefaultValue,
    openEarlyExitTagModal: getOpenEarlyExitTagModalDefaultValue,
});
export const defaultValue = createDefaultContext();
export const SportsbookContext = React.createContext(createDefaultContext());
//# sourceMappingURL=SportsbookContext.js.map